export default __webpack_public_path__ + "static/media/icon-yt.8a90f9bd.svg";